import flyio from "flyio";
 
export async function HTTP(
    url,
    method,
    param={}
) {
    switch (method) {
        case "get":
            if (param && param != {}) {
                let p = "";
                for (let key in param) {
                    if (p != "") {
                        p += "&";
                    }
                    p += key + "=" + param[key];
                }
                url += "?" + p;
            }
            param = {};
            break;
        case "post":
            break;
        case "delete":
            param["_method"] = "DELETE";
            method = "post";
            break;
        case "put":
            param["_method"] = "PUT";
            method = "post";
            break;
        case "option":
            param["_method"] = "OPTION";
            method = "post";
            break;
    }

    flyio.config.baseURL = process.env.VUE_APP_API_URL;

    //添加请求拦截器
    flyio.interceptors.request.use((request) => {
        request.headers = {
            Authorization: window.localStorage.app_token,
        };
        return request;
    });
    //相应拦截器
    flyio.interceptors.response.use((response) => {
        return response.data;
    });

    try{
        let res = await flyio.request(url, param, {method: method,timeout: 100000})
        // console.log('request response',res)
        return res
    }catch(e){
        if(e.status == 401){
            window.localStorage.removeItem('app_token')
            window.location.href="/report/login"
        }
        return {
            code: 500,
            message: 'request_error',
            data:{}
        }
    }
    
} 